import { render, staticRenderFns } from "./RecommendationSubjectList.vue?vue&type=template&id=3e996a96&scoped=true&"
import script from "./RecommendationSubjectList.vue?vue&type=script&lang=js&"
export * from "./RecommendationSubjectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e996a96",
  null
  
)

export default component.exports